import { SilDevice, SilProjectDevice } from "server/models"


export interface SilUpdateState {
    device: {
        targetDevice: SilProjectDevice
        originDevice: SilProjectDevice
    }

    subsystem: {
        targetDevice: SilDevice | SilProjectDevice
        originDevice: SilDevice | SilProjectDevice
    }
}

export const SIL_UPDATE_DEVICE_TARGET_DEVICE = "SIL_UPDATE_DEVICE_TARGET_DEVICE"
export const SIL_UPDATE_DEVICE_ORIGIN_DEVICE = "SIL_UPDATE_DEVICE_ORIGIN_DEVICE"

export const SIL_UPDATE_DEVICE_TARGET_SUBSYSTEM = "SIL_UPDATE_DEVICE_TARGET_SUBSYSTEM"
export const SIL_UPDATE_DEVICE_ORIGIN_SUBSYSTEM = "SIL_UPDATE_DEVICE_ORIGIN_SUBSYSTEM"
